// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3U3e4","topBottomGutter":"Layout_topBottomGutter__1l_W7"};